import React from "react";
import {Alert, Button, Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";

export default function WarningNoAccount() {
    const {t} = useTranslation();

    return (
        <Form>
            <Alert variant="danger">
                {t("helper.noAccount")}
            </Alert>
            <Button type={"submit"}>
                {t("helper.backToHomePage")}
            </Button>
        </Form>
    );
}